// Ref: https://documentation.idmission.com/identity/#appendix-c-form-status-and-state-codes
export enum IDMISSION_DECISION_FAILED_CODE_MAP {
  EXPRIED = '40',
  MRZ_INVALID = '65',
  TAMPERING = '70',
  FACE_MATCH_FAILED = '30',
}

export const I18N_IDMISSION_FAILED_CODE_MESSAGE_MAP: Record<string, string> = {
  [IDMISSION_DECISION_FAILED_CODE_MAP.EXPRIED]:
    'verification.idmission.errors.documentExpired',
  //   [IDMISSION_DECISION_FAILED_CODE_MAP.MRZ_INVALID]: 'MRZ invalid',
  //   [IDMISSION_DECISION_FAILED_CODE_MAP.TAMPERING]: 'Tampering',
  [IDMISSION_DECISION_FAILED_CODE_MAP.FACE_MATCH_FAILED]:
    'verification.idmission.errors.faceMatchFailed',
};

export const IDMISSION_DECISION_FAILED_CODE = [
  IDMISSION_DECISION_FAILED_CODE_MAP.EXPRIED,
];
